exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search-controls {\n  display: flex;\n  align-items: center;\n}\n.search-controls * {\n  margin: 0 10px;\n  white-space: nowrap;\n}\n.search-buttons {\n  cursor: pointer;\n  background-color: transparent;\n  padding: 0;\n}\n.search-buttons img {\n  margin: 0;\n}\n.search-buttons:disabled:hover {\n  opacity: 1;\n}\n.search-buttons--up {\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}", ""]);

// exports
